module.exports = __webpack_public_path__ + "static/img/home-bg-room.d36a48e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home-bg-room.jpg
// module id = fABc
// module chunks = 0